export const QA_NAME_SELECTION_TOOLBAR_CONTENT = 'selectionToolbarContent'

export const QA_NAME_SELECTION_TOOLBAR_CONTENT_SELECTED = 'selected'

export const QA_NAME_SELECTION_TOOLBAR_CONTENT_SELECT_ALL = 'selectAll'

export const QA_NAME_SELECTION_TOOLBAR_CONTENT_UNSELECT_ALL = 'unselectAll'
